import type { ApiFlow } from '../types'
import { commonJwtValidateFlow } from './common.jwt-validate'
import { federationEnterpriseLoginFlow } from './federation.enterprise-login'
import { m2mClientCredentialsFlow } from './m2m.client-credentials'
import { nativeBrowserPkceFlow } from './native.browser-pkce'
import { nativeEmbeddedLoginFlow } from './native.embedded.login'
import { samlIdpSpSetupFlow } from './saml_idp.sp-setup'
import { spaEmbeddedLoginFlow } from './spa.embedded.login'
import { spaHostedOAuthFlow } from './spa.hosted-oauth'
import { webServerOidcFlow } from './web.server-oidc'

export const API_FLOWS: ApiFlow[] = [
  nativeEmbeddedLoginFlow,
  spaHostedOAuthFlow,
  m2mClientCredentialsFlow,
  spaEmbeddedLoginFlow,
  webServerOidcFlow,
  commonJwtValidateFlow,
  nativeBrowserPkceFlow,
  federationEnterpriseLoginFlow,
  samlIdpSpSetupFlow,
]

export const API_FLOW_BY_ID: Record<string, ApiFlow> = Object.fromEntries(
  API_FLOWS.map((f) => [f.id, f]),
)
